const state = {
  params: {
    page: 1,
    per_page: 30,
    q: {
      ticketname: '',
      user_keyword: '',
      status: '',
      pay_status: '',
      start_time: '',
      end_time: '',
      ticket_sn: '',
      shop_name: '',
      activity_name: '',
      ticket_created_start_time: '',
      ticket_created_end_time: '',
      used_start_time: '',
      used_end_time: '',
      user_id: '',
      use_status: ''
    }
  },
  downData: [],
  screenItems: []
};

const mutations = {
  reviseUserGoodsParams(state, val) {
    state.params = val;
  },
  changeUserGoodsDownList(state, val) {
    state.downData = val;
  },
  changeUserGoodsItems(state, val) {
    state.screenItems = val;
  }
};

export default {
  state,
  mutations
};
